import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  DevNote,
  FormFieldSet,
  LogoLoader,
  ProgressTabAdv,
  showToast,
  useFormHandler,
} from "../../../components";
// import Applicant from "./InitiateOnboarding/Applicant";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  fetchEmployeeByUiid,
  fetchLatestUiid,
} from "../../../redux/slices/employee/employeeApi";
import { EmploymentType, Gender } from "../../../assets/data/enumData";
import FillDetailsApplicant from "./InitiateOnboarding/FillDetailsApplicant";
import FillDetailsVendor from "./InitiateOnboarding/FillDetailsVendor";
import FillDetailsClient from "./InitiateOnboarding/FillDetailsClient";
import AddChecklist from "./InitiateOnboarding/AddChecklist";
import {
  addOnboarding,
  fetchOneOnboarding,
  updateOnboarding,
} from "../../../redux/slices/onboarding/onboardingApi";
import { useLoginUser } from "../../../hooks/useLoginUser";
import { fetchOneVendor } from "../../../redux/slices/vendor/vendorApi";
import { fetchOneClient } from "../../../redux/slices/client/clientApi";
import { uploadFiles } from "../../../redux/slices/universal/fileUploadApi";
const addChecklistFormData = {
  onboardDue: "",
  onboardChecklist: "",
  dueDate: "",
  checklistItems: [
    {
      documentCategory: "W2_H1B Onboarding",
      document: "TekTree-OfferLetter-DOC47",
      dueDate: "",
      approvers: "",
      comments: "",
      sendMail: "",
    },
    {
      documentCategory: "Kultworks Workforce",
      document: "Passport-WFSF004",
      dueDate: "",
      approvers: "",
      comments: "",
      sendMail: "",
    },
  ],
};

const initialFormData = {
  employee: "",
  firstName: "",
  middleName: "",
  lastName: "",
  gender: "",
  employmentType: "",
  employeeId: "",
  jobTitle: "",
  email: "",
  alternateEmail: "",
  dateOfBirth: "",
  socialSecurityNumber: "",
  contactNumberCountryCode: "",
  contactNumber: "",
  dateOfJoining: "",
  onboardingCode: "",
  fullAddress: "",
  country: "",
  state: "",
  city: "",
  zipCode: "",
  comments: "",
};

const initialVendorData = {
  vendor: "",
  businessName: "",
  dbaBusinessName: "",
  feinNumber: "",
  vendorFullAddress: "",
  vendorCountry: "",
  vendorState: "",
  vendorCity: "",
  vendorZipcode: "",
  vendorName: "",
  selectPlacementType: "",
  vendorJobTitle: "",
  vendorStartDate: "",
  vendorEndDate: "",
  vendorEmail: "",
  vendorClient: "",
  billRate: "",
  billRateHourly: "",
  taxTerms: "",
  otBillRate: "",
  dtBillRate: "",
  payRate: "",
  payRateHourly: "",
  otPayRate: "",
  primaryContact: "",
  primaryContactNumber: "",
  vendorTitle: "",
  vendorContact: "",
  vendorContactEmail: "",
};

const initialClientData = {
  clientName: "",
  clientBusinessName: "",
  clientDbaBusinessName: "",
  clientFeinNumber: "",
  clientFullAddress: "",
  clientCountry: "",
  clientState: "",
  clientCity: "",
  clientZipCode: "",
  clientVendor: "",
  clientSelectPlacementType: "",
  clientJobTitle: "",
  clientStartDate: "",
  clientEndDate: "",
  clientEmail: "",
  clientPlacementName: "",
  clientBillRate: "",
  clientBillRateHourly: "",
  clientTaxTerms: "",
  clientOtBillRate: "",
  clientDtBillRate: "",
  clientPayRate: "",
  clientPayRateHourly: "",
  clientOtPayRate: "",
  clientPrimaryContact: "",
  clientPrimaryContactNumber: "",
  clientTitle: "",
  clientContact: "",
  clientContactEmail: "",
};

const applicantValidationRules = {
  firstName: { type: "text", required: true },
  lastName: { type: "text", required: true },
  // jobTitleNew: { type: "select", required: true },
  jobTitle: { type: "select", required: true },
  email: { type: "email", required: true },
  dateOfBirth: { type: "date" },
  // contactNumber: { type: "phone", required: true },
  employmentType: { type: "select", required: true },
  dateOfJoining: {
    type: "date",
    required: true,
  },
  country: { type: "select", required: true },
  city: { type: "select", required: true },
  state: { type: "select", required: true },
  // classification: { type: "radio", required: true },
  alternateEmailAddress: { type: "email" },
};

const vendorValidationRules = {
  businessName: { type: "text", required: true },
  feinNumber: { type: "text", required: true },
};

const clientValidationRules = {
  clientBusinessName: { type: "text", required: true },
};

const InitiateOnboarding = () => {
  const location = useLocation();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  //as user comes from any location take thei employeeD from state
  const [employeeId, setEmployeeId] = useState(
    location?.state?.employeeId || null,
  );
  const [onboardingId, setOnboardingId] = useState(
    location?.state?.onboardingCode || null,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchedEntity, setIsFetchedEntity] = useState(false);
  const [selectedType, setSelectedType] = useState("applicant");
  const entityTypeConfig = {
    1: "applicant",
    2: "vendor",
    3: "client",
  };
  const [onboardingDoc, setOnboardingDoc] = useState({});

  const [status, setStatus] = useState(1);
  // const [onboardDue, setOnboardDue] = useState();
  // const [toggleInput, setToggleInput] = useState(true);
  // const [activeTab, setActiveTab] = useState("Applicant");
  const navigate = useNavigate();

  //as user comes from any location take thei employeeD from state

  const [validationRules, setValidationRules] = useState({});

  // const [onboardDue, setOnboardDue] = useState();
  // const [toggleInput, setToggleInput] = useState(true);
  // const [activeTab, setActiveTab] = useState("Applicant");

  useEffect(() => {
    if (selectedType === "applicant") {
      // setValidationRules(applicantValidationRules);
      setValidationRules({});
    } else if (selectedType === "vendor") {
      setValidationRules({});
    } else if (selectedType === "client") {
      setValidationRules({});
    }
  }, [selectedType]);

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  const handleSubmit = async (status) => {
    try {
      const isValid = validateAllFields();
      if (!isValid) {
        showToast("Please fill all required fields", "error");
        return;
      }
      const statusToBeSent = status ? status : undefined;
      if (!onboardingId) {
        let createPayload = null;
        switch (selectedType) {
          case "applicant": {
            createPayload = {
              status: statusToBeSent,
              entity: {
                type: 1,
                id: formData?.employee?.value,
              },
              comments: formData?.comments || "",
              addedBy: loginUserUiid,
            };
            break;
          }
          case "vendor": {
            createPayload = {
              status: statusToBeSent,
              entity: {
                type: 2,
                id: formData?.vendor?.value,
              },
              placement: {
                type: formData?.selectPlacementType || null, // Contract, Full-time
                jobTitle: formData?.vendorJobTitle || "",
                startDate: formData?.vendorStartDate,
                endDate: formData?.vendorEndDate,
                email: formData?.vendorEmail,
                name: formData?.vendorClient,
                billRate: formData?.billRate,
                billRateType: formData?.billRateHourly, // hourly, fixed
                taxTerms: formData?.taxTerms, // one-term, two-term
                otBillRate: formData?.otBillRate,
              },
              addedBy: loginUserUiid,
            };
            break;
          }
          case "client": {
            createPayload = {
              status: statusToBeSent,
              entity: {
                type: 3,
                id: formData?.clientName?.value,
              },
              placement: {
                type: formData?.clientSelectPlacementType || null, // Contract, Full-time
                jobTitle: formData?.clientJobTitle || "",
                startDate: formData?.clientStartDate,
                endDate: formData?.clientEndDate,
                email: formData?.clientEmail,
                name: formData?.clientCandidateName,
                billRate: formData?.clientBillRate,
                billRateType: formData?.clientBillRateHourly, // hourly, fixed
                taxTerms: formData?.clientTaxTerms, // one-term, two-term
                otBillRate: formData?.clientOtBillRate,
              },
              addedBy: loginUserUiid,
            };
            break;
          }
          default:
            showToast("Something Went Wrong!", "error");
        }
        const res = await addOnboarding(createPayload);
        if (!res?.success) {
          showToast("Something Went Wrong", "error");
          return;
        }
        if (!res?.data?.data?.onboardId) {
          showToast("Something Went Wrong", "error");
          navigate(-1);
          return;
        }

        if (statusToBeSent === 2) {
          navigate(
            "/e-onboarding?e-onboarding=dashboard&e-onboarding-dashboard=draft#initiate-onboarding",
            {
              state: {
                entityFromInitiate:
                  selectedType === "applicant"
                    ? 1
                    : selectedType === "vendor"
                      ? 2
                      : selectedType === "client"
                        ? 3
                        : null,
              },
            },
          );
        } else {
          const onboardingData = await fetchOneOnboarding({
            uiid: res?.data?.data?.onboardId,
          });
          setOnboardingDoc(onboardingData?.data?.data || {});
          setStatus(2);
        }
      } else {
        let updatePayload = [];
        switch (selectedType) {
          case "applicant": {
            updatePayload = [
              {
                type: "SET",
                value: {
                  status: statusToBeSent,
                  comments: formData?.comments || "",
                },
              },
            ];
            break;
          }
          case "vendor": {
            updatePayload = [
              {
                type: "SET",
                value: {
                  status: statusToBeSent,
                  placement: {
                    type: formData?.selectPlacementType || null, // Contract, Full-time
                    jobTitle: formData?.vendorJobTitle || "",
                    startDate: formData?.vendorStartDate,
                    endDate: formData?.vendorEndDate,
                    email: formData?.vendorEmail,
                    name: formData?.vendorClient,
                    billRate: formData?.billRate,
                    billRateType: formData?.billRateHourly, // hourly, fixed
                    taxTerms: formData?.taxTerms, // one-term, two-term
                    otBillRate: formData?.otBillRate,
                  },
                },
              },
            ];
            break;
          }
          case "client": {
            updatePayload = [
              {
                type: "SET",
                value: {
                  status: statusToBeSent,
                  placement: {
                    type: formData?.clientSelectPlacementType || null, // Contract, Full-time
                    jobTitle: formData?.clientJobTitle || "",
                    startDate: formData?.clientStartDate,
                    endDate: formData?.clientEndDate,
                    email: formData?.clientEmail,
                    name: formData?.clientCandidateName,
                    billRate: formData?.clientBillRate,
                    billRateType: formData?.clientBillRateHourly, // hourly, fixed
                    taxTerms: formData?.clientTaxTerms, // one-term, two-term
                    otBillRate: formData?.clientOtBillRate,
                  },
                },
              },
            ];
            break;
          }
          default:
            showToast("Something Went Wrong!", "error");
        }
        const updateRes = await updateOnboarding({
          coll: "Onboarding",
          uiid: onboardingId,
          payload: updatePayload,
        });
        if (!updateRes?.success) {
          showToast("Something Went Wrong", "error");
          return;
        } else {
          showToast("Onboarding Updated Successfully", "success");
        }
        if (statusToBeSent === 2) {
          // navigate(-1);
          navigate(
            "/e-onboarding?e-onboarding=dashboard&e-onboarding-dashboard=draft#initiate-onboarding",
            {
              state: {
                entityFromInitiate:
                  selectedType === "applicant"
                    ? 1
                    : selectedType === "vendor"
                      ? 2
                      : selectedType === "client"
                        ? 3
                        : null,
              },
            },
          );
        } else {
          setStatus(2);
        }
      }
    } catch (error) {
      showToast("An error occurred handleSubmit Fill Details", "error");
      console.error("Error in handleSubmit",error);
    }
  };
  const handleChecklistSave = async (status) => {
    // return;
    try {
      if (!onboardingDoc?.uiid) {
        console.error("There is no onboardingDoc?.uiid");
        showToast("Something Went Wrong", "error");
        return;
      }
      const statusToBeSent = status ? status : undefined;
      let updatePayload = [];
      const documents = await Promise.all(
        (formData?.updatedChecklistsForSave || []).map(async (data) => {
          const fields = await Promise.all(
            Object.entries(data?.metaData?.id?.fields || {}).flatMap(
              ([_, list]) =>
                (list || []).map(async (item) => {
                  let value = item.value;
      
                  if (item.type === "image" && typeof value !== "string") {
                    const uint8Array = new Uint8Array(value);
                    const file = new File(
                      [uint8Array],
                      `${item.id}.png`,
                      { type: "image/*" }
                    );
      
                    const uploadRes = await uploadFiles({
                      uploadType: "single",
                      field: "doc",
                      uiid: onboardingDoc?.uiid,
                      entity: "onboardings",
                      category: "checklist_image",
                      coll: "Onboarding",
                      doc: file,
                    });
      
                    const url = uploadRes?.data?.data?.url;
                    if (!url) throw new Error("Image upload failed");
      
                    value = url;
                  }
      
                  return {
                    id: item.id,
                    value,
                    type: item.type,
                  };
                })
            )
          );
      
          return {
            ...(data.id && { _id: data.id }),
            id: data?.metaData?.id?.uiid,
            approver: data?.approvers,
            initiator: isNaN(data?.initiator)
              ? data?.initiator?.uiid || data?.initiator?.value
              : data?.initiator,
            initiatedOn: data?.initiatedOn || new Date(),
            dueDate: data?.dueDate,
            mail: data?.sendMail === "1",
            comment: data?.comments || "",
            fields,
          };
        })
      );

      updatePayload = [
        {
          // type: onboardingDoc?.checklists?.length > 0 ? "SET" : "PUSH",
          type: "SET",
          value: {
            _skipFlatten: ["checklists"],
            ...(statusToBeSent && { status: statusToBeSent }),
            onboardDue: formData?.onboardDue,
            checklists: [
              {
                id:
                  formData?.onboardChecklist?.value ??
                  formData?.onboardChecklist,
                dueDate: formData?.dueDate,
                documents
              },
            ],
          },
        },
      ];
      console.log({updatePayload})
      // return;
      const updateRes = await updateOnboarding({
        coll: "Onboarding",
        uiid: onboardingId ?? onboardingDoc?.uiid,
        payload: updatePayload,
        ...(status === 3 && { postActions: ["CheckListSendEmail"]})
      });
      if (!updateRes.success) {
        showToast("Something Went Wrong", "error");
        return;
      }
      if (statusToBeSent === 2) {
        navigate(
          "/e-onboarding?e-onboarding=dashboard&e-onboarding-dashboard=draft#initiate-onboarding",
          {
            state: {
              entityFromInitiate:
                selectedType === "applicant"
                  ? 1
                  : selectedType === "vendor"
                    ? 2
                    : selectedType === "client"
                      ? 3
                      : null,
            },
          },
        );
      } else {
        navigate(-1);
      }
    } catch (error) {
      showToast("An error occurred handleChecklistSave Fill Details", "error");
      console.error(error);
    }
  };
  const fetchEmployee = async (id) => {
    console.warn("fetchEmployee triggered::::::::::");
    try {
      setIsLoading(true);
      const response = await fetchEmployeeByUiid({
        uiid: id,
        ret: "uiid firstName middleName lastName gender employmentType jobTitle email dob ssn mobile joinDate location",
      });
      let employeeData = response?.data?.data || {};
      if (employeeData.uiid) {
        setIsFetchedEntity(true);
      }
      handleChange("firstName", employeeData.firstName);
      handleChange("middleName", employeeData.middleName);
      handleChange("lastName", employeeData.lastName);
      handleChange("gender", employeeData.gender);
      handleChange("employmentType", employeeData.employmentType);
      handleChange("employeeId", employeeData.uiid);
      handleChange("employee", {
        label: employeeData.firstName + " " + employeeData.lastName,
        value: employeeData.uiid,
      });
      handleChange("jobTitle", employeeData.jobTitle);
      handleChange("email", employeeData.email.primary);
      handleChange("alternateEmail", employeeData.email.secondary);
      handleChange("dateOfBirth", employeeData.dob);
      handleChange("socialSecurityNumber", employeeData.ssn.number);
      handleChange(
        "contactNumberCountryCode",
        employeeData.mobile.primary.code,
      );
      handleChange("contactNumber", employeeData.mobile.primary.number);
      handleChange("dateOfJoining", employeeData.joinDate);
      handleChange(
        "fullAddress",
        `${employeeData.location?.address1 || ""} ${
          employeeData.location?.address2 || ""
        }`,
      );
      handleChange("country", employeeData.location?.country || "");
      handleChange("state", employeeData.location?.state || "");
      handleChange("city", employeeData.location?.city || "");
      handleChange("zipCode", employeeData.location?.zipCode || "");
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchVendor = async (id) => {
    console.warn("fetchVendor triggered::::::::::");
    try {
      setIsLoading(true);
      const response = await fetchOneVendor({
        vendorUiid: id,
        retrieve: "uiid businessName dbaName federalId generalInfo.locations",
        ref: "Contact",
      });
      let vendorData = response?.data || {};
      if (vendorData.uiid) {
        setIsFetchedEntity(true);
      }
      const locationToConsider =
        vendorData?.generalInfo?.locations?.find(
          (data) => data.isDefaultBilling,
        ) || {};
      const contactInfo = vendorData?.contacts?.[0] || {};
      handleChange("businessName", vendorData?.businessName || "");
      handleChange("vendorName", vendorData?.businessName || "");
      handleChange("dbaBusinessName", vendorData?.businessName || "");
      handleChange("feinNumber", vendorData?.federalId || "");
      handleChange(
        "vendorFullAddress",
        (locationToConsider?.address1 || "") +
          " " +
          (locationToConsider?.address2 || ""),
      );
      handleChange("vendorCountry", locationToConsider?.country);
      handleChange("vendorState", locationToConsider?.state);
      handleChange("vendorCity", locationToConsider?.city);
      handleChange("vendorZipcode", locationToConsider?.zipCode);
      handleChange("primaryContactNumber", contactInfo?.representativeName);
      handleChange("vendorTitle", contactInfo?.jobTitle);
      handleChange("vendorContactEmail", contactInfo?.email);
      handleChange(
        "vendorContact",
        (contactInfo?.phone?.main?.code || "") +
          (contactInfo?.phone?.main?.number || ""),
      );
    } catch (error) {
      console.error("fetchVendor", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchClient = async (id) => {
    console.warn("fetchClient triggered::::::::::");
    try {
      setIsLoading(true);
      const response = await fetchOneClient({
        clientUiid: id,
        retrieve: "uiid businessName dbaName federalId generalInfo.locations",
        ref: "Contact",
      });
      let clientData = response?.data?.data || {};
      if (clientData.uiid) {
        setIsFetchedEntity(true);
      }
      const locationToConsider =
        clientData?.generalInfo?.locations?.find(
          (data) => data.isDefaultInvoice,
        ) || {};
      const contactInfo = clientData?.contacts?.[0] || {};
      handleChange("clientBusinessName", clientData?.businessName || "");
      handleChange("clientVendor", clientData?.businessName || "");
      handleChange("clientDbaBusinessName", clientData?.businessName || "");
      handleChange("clientFeinNumber", clientData?.federalId || "");
      handleChange(
        "clientFullAddress",
        (locationToConsider?.address1 || "") +
          " " +
          (locationToConsider?.address2 || ""),
      );
      handleChange("clientCountry", locationToConsider?.country);
      handleChange("clientState", locationToConsider?.state);
      handleChange("clientCity", locationToConsider?.city);
      handleChange("clientZipCode", locationToConsider?.zipCode);
      handleChange(
        "clientPrimaryContactNumber",
        contactInfo?.representativeName,
      );
      handleChange("clientTitle", contactInfo?.jobTitle);
      handleChange("clientContactEmail", contactInfo?.email);
      handleChange(
        "clientContact",
        (contactInfo?.phone?.main?.code || "") +
          (contactInfo?.phone?.main?.number || ""),
      );
    } catch (error) {
      console.error("clientData", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchOnboardingAndPrefill = async (onboardingId) => {
    try {
      //if multiple checklists added this api structure will change
      setIsLoading(true);
      const refConfig = {
        1: {
          ref: "Employee",
          incl: "firstName middleName lastName gender employmentType uiid jobTitle email dob ssn.number mobile joinDate location",
        },
        2: {
          ref: "Entity",
          incl: "generalInfo.locations contacts businessName federalId",
        },
        3: {
          ref: "Entity",
          incl: "generalInfo.locations contacts businessName federalId",
        },
      };
      if (!refConfig[location?.state.entityType]) {
        showToast("Reference Config Error", "error");
        throw new Error(
          "Reference Config Error , No location?.state.entityType found to fetchOnboardingAndPrefill ",
        );
      }
      const res = await fetchOneOnboarding({
        uiid: onboardingId,
        // ref: `${refConfig[location?.state.entityType]} Checklist PdfTemplate`,
        ref: `${refConfig[location?.state.entityType]?.ref} Checklist PdfTemplateWithInitator OnboardingDocInitiator`,
        incl: [
          refConfig[location?.state.entityType]?.incl || "",
          "",
          "",
          "firstName lastName uiid",
        ],
      });
      setOnboardingDoc(res?.data?.data || {});
      const entityType = res?.data?.data?.entity?.type;
      if (!entityType) {
        showToast("Something Went Wrong!", "error");
        throw new Error("No entityType found in API");
      }
      setSelectedType(entityTypeConfig[entityType]);
      const onboardingDoc = res?.data?.data;
      setOnboardingDoc(onboardingDoc);
      const entityData = onboardingDoc?.entity?.id || {};
      switch (entityTypeConfig[entityType]) {
        case "applicant": {
          handleChange("firstName", entityData.firstName);
          handleChange("middleName", entityData.middleName);
          handleChange("lastName", entityData.lastName);
          handleChange("gender", entityData.gender);
          handleChange("employmentType", entityData.employmentType);
          handleChange("employeeId", entityData.uiid);
          handleChange("employee", {
            label: entityData.firstName + " " + entityData.lastName,
            value: entityData.uiid,
          });
          handleChange("jobTitle", entityData.jobTitle);
          handleChange("email", entityData.email.primary);
          handleChange("alternateEmail", entityData.email.secondary);
          handleChange("dateOfBirth", entityData.dob);
          handleChange("socialSecurityNumber", entityData?.ssn?.number || "");
          handleChange(
            "contactNumberCountryCode",
            entityData.mobile.primary.code,
          );
          handleChange("contactNumber", entityData.mobile.primary.number);
          handleChange("dateOfJoining", entityData.joinDate);
          handleChange("onboardingCode", 456);
          handleChange(
            "fullAddress",
            `${entityData.location?.address1 || ""} ${
              entityData.location?.address2 || ""
            }`,
          );
          handleChange("country", entityData.location?.country || "");
          handleChange("state", entityData.location?.state || "");
          handleChange("city", entityData.location?.city || "");
          handleChange("zipCode", entityData.location?.zipCode || "");
          handleChange("onboardingCode", onboardingDoc?.uiid);
          handleChange("comments", onboardingDoc?.comments || "");
          handleChange("onboardDue", onboardingDoc?.onboardDue || "");
          handleChange(
            "onboardChecklist",
            onboardingDoc?.checklists?.[0]?.id?.uiid
              ? {
                  label: onboardingDoc?.checklists?.[0]?.id?.name,
                  value: onboardingDoc?.checklists?.[0]?.id?.uiid,
                }
              : "",
          );
          handleChange(
            "dueDate",
            onboardingDoc?.checklists?.[0]?.dueDate || "",
          );
          handleChange(
            "checklistItems",
            onboardingDoc?.checklists?.[0]?.documents || [],
          );
          break;
        }
        case "vendor": {
          const locationToConsider =
            entityData?.generalInfo?.locations?.find(
              (data) => data.isDefaultBilling,
            ) || {};
          const contactInfo = entityData?.contacts?.[0] || {};
          handleChange("businessName", entityData?.businessName || "");
          handleChange("dbaBusinessName", entityData?.businessName || "");
          handleChange("feinNumber", entityData?.federalId || "");
          handleChange(
            "vendorFullAddress",
            (locationToConsider?.address1 || "") +
              " " +
              (locationToConsider?.address2 || ""),
          );
          handleChange("vendorCountry", locationToConsider?.country);
          handleChange("vendorState", locationToConsider?.state);
          handleChange("vendorCity", locationToConsider?.city);
          handleChange("vendorZipcode", locationToConsider?.zipCode);
          handleChange("primaryContactNumber", contactInfo?.representativeName);
          handleChange("vendorTitle", contactInfo?.jobTitle);
          handleChange("vendorContactEmail", contactInfo?.email);
          handleChange(
            "vendorContact",
            contactInfo?.phone?.main?.code && contactInfo?.phone?.main?.number
              ? contactInfo?.phone?.main?.code +
                  contactInfo?.phone?.main?.number
              : "",
          );
          handleChange("vendorName", entityData?.businessName);
          handleChange("selectPlacementType", onboardingDoc?.placement?.type);
          handleChange("vendorJobTitle", onboardingDoc?.placement?.jobTitle);
          handleChange("vendorStartDate", onboardingDoc?.placement?.startDate);
          handleChange("vendorEndDate", onboardingDoc?.placement?.endDate);
          handleChange("vendorEmail", onboardingDoc?.placement?.email);
          handleChange("vendorClient", onboardingDoc?.placement?.name);
          handleChange("billRate", onboardingDoc?.placement?.billRate);
          handleChange(
            "billRateHourly",
            onboardingDoc?.placement?.billRateType,
          );
          handleChange("taxTerms", onboardingDoc?.placement?.taxTerms);
          handleChange("otBillRate", onboardingDoc?.placement?.otBillRate);
          handleChange("onboardDue", onboardingDoc?.onboardDue || "");
          handleChange(
            "onboardChecklist",
            onboardingDoc?.checklists?.[0]?.id?.uiid
              ? {
                  label: onboardingDoc?.checklists?.[0]?.id?.name,
                  value: onboardingDoc?.checklists?.[0]?.id?.uiid,
                }
              : "",
          );
          handleChange(
            "dueDate",
            onboardingDoc?.checklists?.[0]?.dueDate || "",
          );
          handleChange(
            "checklistItems",
            onboardingDoc?.checklists?.[0]?.documents || [],
          );
          break;
        }
        case "client": {
          const locationToConsider =
            entityData?.generalInfo?.locations?.find(
              (data) => data.isDefaultBilling,
            ) || {};
          const contactInfo = entityData?.contacts?.[0] || {};
          handleChange("clientBusinessName", entityData?.businessName || "");
          handleChange("clientVendor", entityData?.businessName || "");
          handleChange("clientDbaBusinessName", entityData?.businessName || "");
          handleChange("clientFeinNumber", entityData?.federalId || "");
          handleChange(
            "clientFullAddress",
            (locationToConsider?.address1 || "") +
              " " +
              (locationToConsider?.address2 || ""),
          );
          handleChange("clientCountry", locationToConsider?.country);
          handleChange("clientState", locationToConsider?.state);
          handleChange("clientCity", locationToConsider?.city);
          handleChange("clientZipCode", locationToConsider?.zipCode);
          handleChange(
            "clientPrimaryContactNumber",
            contactInfo?.representativeName,
          );
          handleChange("clientTitle", contactInfo?.jobTitle);
          handleChange("clientContactEmail", contactInfo?.email);
          handleChange(
            "clientContact",
            (contactInfo?.phone?.main?.code || "") +
              (contactInfo?.phone?.main?.number || ""),
          );
          //placement
          handleChange(
            "clientSelectPlacementType",
            onboardingDoc?.placement?.type,
          );
          handleChange("clientJobTitle", onboardingDoc?.placement?.jobTitle);
          handleChange("clientStartDate", onboardingDoc?.placement?.startDate);
          handleChange("clientEndDate", onboardingDoc?.placement?.endDate);
          handleChange("clientEmail", onboardingDoc?.placement?.email);
          handleChange("clientCandidateName", onboardingDoc?.placement?.name);
          handleChange("clientBillRate", onboardingDoc?.placement?.billRate);
          handleChange(
            "clientBillRateHourly",
            onboardingDoc?.placement?.billRateType,
          );
          handleChange("clientTaxTerms", onboardingDoc?.placement?.taxTerms);
          handleChange(
            "clientOtBillRate",
            onboardingDoc?.placement?.otBillRate,
          );
          handleChange("onboardDue", onboardingDoc?.onboardDue || "");
          handleChange(
            "onboardChecklist",
            onboardingDoc?.checklists?.[0]?.id?.uiid
              ? {
                  label: onboardingDoc?.checklists?.[0]?.id?.name,
                  value: onboardingDoc?.checklists?.[0]?.id?.uiid,
                }
              : "",
          );
          handleChange(
            "dueDate",
            onboardingDoc?.checklists?.[0]?.dueDate || "",
          );
          handleChange(
            "checklistItems",
            onboardingDoc?.checklists?.[0]?.documents || [],
          );
          break;
        }
        default:
          showToast("Something Went Wrong!", "error");
      }
    } catch (err) {
      console.error("Error in fetchOnboardingAndPrefill", err);
    } finally {
      setIsLoading(false);
    }
  };
  // onEmployee dropdown change listener
  useEffect(() => {
    if (!onboardingId) {
      if (employeeId || formData?.employee?.value) {
        let id = formData?.employee?.value
          ? formData?.employee?.value
          : employeeId;
        fetchEmployee(id);
      }
    }
  }, [employeeId, formData?.employee?.value]);

  // onVendor dropdown change listener
  useEffect(() => {
    if (!onboardingId) {
      if (formData?.vendor?.value) {
        fetchVendor(formData?.vendor?.value);
      }
    }
  }, [formData?.vendor?.value]);

  // onClient dropdown change listener
  useEffect(() => {
    if (!onboardingId) {
      if (formData?.clientName?.value) {
        fetchClient(formData?.clientName?.value);
      }
    }
  }, [formData?.clientName?.value]);

  // prefill the data in the forms from the onboardId exists
  useEffect(() => {
    if (onboardingId) {
      fetchOnboardingAndPrefill(onboardingId);
    }
  }, [onboardingId]);

  // on add screen fetches the latest onbvoarding coide
  useEffect(() => {
    const fetchLatestUiidData = async () => {
      try {
        const response = await fetchLatestUiid("onboardings");
        const count = response?.data?.data?.count;

        if (typeof count === "number") {
          handleChange("onboardingCode", count + 1);
          // setLatestUiid(count + 1);
        } else {
          handleChange("onboardingCode", count);
          // setLatestUiid(1);
        }
      } catch (error) {
        // showToast("Error fetching latest UIID", "error", 5000);
        handleChange("onboardingCode", 1);
        // setLatestUiid(1);
      }
    };
    if (!employeeId || !onboardingId) {
      fetchLatestUiidData();
    }
  }, []);

  const progressTabs = [
    {
      title: "Fill Details",
      icon: "group_add",
      color: status !== 1 ? "success" : "primary",
      status: status !== 1 ? "Completed" : "In Progress",
    },
    {
      title: "Add Checklist",
      icon: "checklist_rtl",
      color: status === 2 ? "primary" : status > 2 ? "success" : "",
      status: status === 2 ? "In Progress" : status > 2 ? "Completed" : "",
    },
    // {
    //   title: "Initiate Onboarding",
    //   icon: "airplane_ticket",
    //   color: status === 3 ? "primary" : "",
    //   status: status === 3 ? "In Progress" : "",
    // },
  ];

  <Button
    className="self-end my-4 mx-3"
    title={"Submit"}
    //onClick={() => navigate("/e-onboarding#dashboard/initiated")}
    onClick={() =>
      navigate(
        "/e-onboarding?e-onboarding=dashboard&e-onboarding-dashboard=initiated",
      )
    }
  />;

  const tabClicked = (value) => {
    if (value.title === "Fill Details") {
      setStatus(1);
    } else if (value.title === "Add Checklist") {
      setStatus(2);
    }
  };

  const getTitle = () => {
    switch (selectedType) {
      case "applicant":
        return "General";
      case "vendor":
        return "Vendor General Information";
      case "client":
        return "Client General Information";
      default:
        return "General";
    }
  };

  const showIcon = selectedType === "applicant";

  return (
    <>
      <DevNote>
        <div>
          <h6>employeeId: {employeeId}</h6>
          <h6>onboardingId: {onboardingId}</h6>
          <br />
          <Button
            title={"Refresh Onboarding Fetch and Prefill"}
            icon={"refresh"}
            variant="outlined"
            onClick={() => fetchOnboardingAndPrefill(onboardingId)}
          />
        </div>
      </DevNote>
      <div className="flex flex-col flex-1 my-2 border-2 border-gray-100 rounded-lg shadow">
        <div className=" flex justify-around items-start mx-6 my-3 gap-2">
          {status === 2 && (
            <Button
              title={"Back"}
              icon={"west"}
              onClick={() => setStatus(1)}
              variant="text"
              color="black"
              className="font-semibold !px-2 !py-4 !bg-transparent"
            />
          )}
          <ProgressTabAdv
            tabs={progressTabs}
            activeTab={status}
            onTabClick={tabClicked}
          />
        </div>

        {status === 1 && (
          <div className="flex flex-col h-full">
            <div className="flex justify-between items-center px-4 py-2">
              <div className="flex items-center gap-2">
                {showIcon && (
                  <Button
                    type="icon"
                    icon="badge"
                    variant="text"
                    color="black"
                  />
                )}
                <span className="text-xl font-normal">{getTitle()}</span>
              </div>

              <div className="flex gap-0 min-w-[320px]">
                <Button
                  title="Applicant"
                  variant={
                    selectedType === "applicant" ? "contained" : "outlined"
                  }
                  className="rounded-none"
                  onClick={() => {
                    if (onboardingId) return;
                    setSelectedType("applicant");
                    setFormData(initialFormData);
                  }}
                  disabled={onboardingId && location?.state?.entityType !== 1}
                />
                <Button
                  title="Vendor"
                  variant={selectedType === "vendor" ? "contained" : "outlined"}
                  className="rounded-none border-x-0"
                  onClick={() => {
                    if (onboardingId) return;
                    setSelectedType("vendor");
                    setFormData(initialVendorData);
                  }}
                  disabled={onboardingId && location?.state?.entityType !== 2}
                />
                <Button
                  title="Client"
                  variant={selectedType === "client" ? "contained" : "outlined"}
                  className="rounded-none"
                  onClick={() => {
                    if (onboardingId) return;
                    setSelectedType("client");
                    setFormData(initialClientData);
                  }}
                  disabled={onboardingId && location?.state?.entityType !== 3}
                />
              </div>
            </div>

            {selectedType === "applicant" && (
              <FillDetailsApplicant
                formData={formData}
                errors={errors}
                handleChange={handleChange}
                isFetchedEntity={isFetchedEntity}
                onboardingId={onboardingId}
              />
            )}

            {selectedType === "vendor" && (
              <FillDetailsVendor
                formData={formData}
                errors={errors}
                handleChange={handleChange}
                isFetchedEntity={isFetchedEntity}
                onboardingId={onboardingId}
              />
            )}

            {selectedType === "client" && (
              <FillDetailsClient
                formData={formData}
                errors={errors}
                handleChange={handleChange}
                isFetchedEntity={isFetchedEntity}
                onboardingId={onboardingId}
              />
            )}

            <div className="flex justify-end gap-4 me-10 mt-20 mb-10">
              <Button
                title={"Cancel"}
                variant="outlined"
                onClick={() =>
                  navigate("/e-onboarding", {
                    state: {
                      entityFromInitiate:
                        selectedType === "applicant"
                          ? 1
                          : selectedType === "vendor"
                            ? 2
                            : selectedType === "client"
                              ? 3
                              : null,
                    },
                  })
                }
              />
              <Button
                title={"Save as Draft"}
                variant="outlined"
                onClick={() => handleSubmit(2)}
              />
              <Button
                title={"Save & Next"}
                onClick={() => handleSubmit(null)}
              />
            </div>
          </div>
        )}

        {status === 2 && (
          <AddChecklist
            selectedType={selectedType}
            onboardingId={onboardingId}
            employeeId={employeeId}
            onboardingDoc={onboardingDoc}
            formData={formData}
            handleChange={handleChange}
            errors={errors}
            handleSubmit={handleChecklistSave}
          />
        )}
      </div>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </>
  );
};

export default InitiateOnboarding;
